export const STANDARD = 'STANDARD';
export const GOTO = 'GOTO';